export default "__VITE_ASSET__Cz_ohwFl__"